export const fromatNameForSave = (name: string) => {
const formattedName = name
    .toLowerCase()
    .replaceAll("ā","a")
    .replaceAll("ē","e")
    .replaceAll("ī","i")
    .replaceAll("ū","u")
    .replaceAll("č","c")
    .replaceAll("ģ","g")
    .replaceAll("ķ","k")
    .replaceAll("ļ","k")
    .replaceAll("ņ","n")
    .replaceAll("š","s")
    .replaceAll("ž","z")
    .split(" ").join("_");

    return formattedName || ""
}
